import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ConfirmPassword, CurrentPassword, Message, SubmitClearButton, Title } from './ClientUtil';
import { validateConfirmPassword, validatePassword } from './ClientValidate';
import { axiosErrorHandler, axiosPostWithHeader, axiosResponseHandler, ShowAlertError } from '../Common/axios';
import { SingleButton } from '../Login/LoginUtil';
import { encrypt } from '../Common/Util';

export function ChangePassword (props) {
  const [message, setMessage] = useState('');
  const [currentpassword, setCurrentpassword] = useState('');
  const [password, setPassword] = useState('');
  const [confirmpassword, setConfirmpassword] = useState('');
  const currentpasswordReference = useRef();
  const passwordReference = useRef();
  const confirmpasswordReference = useRef();
  const [errorAlert, setErrorAlert] = useState(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleBack = (event) => {
    setTimeout(() => {
      navigate('/profile.html', { replace: true });
    }, 100);
  }

  const handleInput = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    switch(name) {
      case 'currentpassword': setCurrentpassword(value); break;
      case 'password': setPassword(value); break;
      case 'confirmpassword': setConfirmpassword(value); break;
      case 'message': setMessage(value); break;
      default : 
    }
  }

  const handleReset = (event) =>{
    const value="";
    setCurrentpassword(value);
    setPassword(value);
    setConfirmpassword(value);
    setMessage(value);
    currentpasswordReference.current.focus();
  }

  const handleSubmit =  (event) => {
    var msg = '';
    if(msg==='') msg = validatePassword(event,currentpasswordReference,currentpassword);
    if(msg==='') msg = validateConfirmPassword(event, passwordReference,password, confirmpasswordReference, confirmpassword);
    if(msg==='' && currentpassword===password) {
      msg = "New password can not be current password";
    }  
    setMessage(msg); 

    if(msg==='') {
      const data = {
        oldPassword: ''+encrypt(currentpassword),
        newPassword: ''+encrypt(password),
        confirmPassword: ''+encrypt(confirmpassword),
      }
      axiosPostWithHeader("/astrologer/changepassword", data,
        (response)=>{
          setMessage(axiosResponseHandler(response, currentpasswordReference, ()=>handleReset(), "Your password is changed successfully"));
          if(response.data.code==='200') {
            setSuccess(true);
          }
        },
        (error)=>{
          setMessage(axiosErrorHandler(currentpasswordReference,error));
          setErrorAlert(error.message);
        }
      );
    }
    event.preventDefault();
  }

  return(
    <>
      <div class="m-0 p-0 row align-items-top">
        <div class="col-sm-2 col-md-2 d-none d-md-block"></div>    
        <div class="col-sm-12 col-md-8 m-0 p-2 bg-white text-black">
          <Title title="Change password" urlcallback={handleBack}></Title>
          <div class="row m-0 p-0 w-100 border rounded">
            <div class="col m-0 p-0 justify-content-center">
              <div class="row m-0 p-0 w-100">
              <div class="col-3 d-none d-lg-block"></div>
              <div class="col-sm-12 col-lg-6">
                <Message msg={message} /> 
                {success===false?
                <form method="post" onSubmit={handleSubmit}>
                  <CurrentPassword reference={currentpasswordReference} data={currentpassword} callback={handleInput} />
                  <ConfirmPassword reference={passwordReference} confirmreference={confirmpasswordReference} value={password} confirmvalue={confirmpassword} callback={handleInput} />
                  <SubmitClearButton callback={handleReset} /> 
                </form>
                : <SingleButton title="Ok" callback={handleBack}/>
                }
              </div>  
              <div class="col-3 d-none d-lg-block"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-2 col-md-2 d-none d-md-block"></div>    
        <ShowAlertError errorAlert={errorAlert} setErrorAlert={setErrorAlert}/>
      </div>
    </>
  );
}
